import { LightTooltip } from '../min-sidebar-community-list/MinSidebarCommunityList';
import C from './JamCard.css';
import React from 'react';

import NounGroupIcon from '!!react-svg-loader!../welcome-page/noun-group.svg';
import { Jam } from '../../atoms/jams';
import { plural } from '@lingui/macro';

export default function CoCreatorCountTag(props: { jam: Jam }) {
  return (
    <LightTooltip
      title={plural(props.jam.participantCount, {
        one: 'Co-creator',
        other: 'Co-creators',
      })}
      arrow
    >
      <div className={C.spotCount}>
        <NounGroupIcon style={{ width: 15, height: 15 }} />{' '}
        {props.jam.participantCount}
      </div>
    </LightTooltip>
  );
}
